import { Link } from "react-router-dom";
import { Card, Typography, Space, Divider } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

export default function PrivacyPolicyPage() {
	return (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "flex-start",
				justifyContent: "center",
				background: "#f5f5f5",
				padding: "48px 16px",
			}}
		>
			<Card
				style={{
					width: "100%",
					maxWidth: 720,
					boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
				}}
			>
				<Space direction="vertical" size="middle" style={{ width: "100%" }}>
					<div style={{ textAlign: "center" }}>
						<Title level={2} style={{ marginBottom: 4 }}>
							Privacy Policy
						</Title>
						<Text type="secondary">
							Agile &amp; Co &mdash; Last updated: February 2026
						</Text>
					</div>

					<Divider style={{ margin: "8px 0" }} />

					<section>
						<Title level={4} className="text-coral">
							1. Introduction
						</Title>
						<Paragraph>
							Agile &amp; Co ("we", "us", or "our") operates the AgileCo SEO
							Platform. This Privacy Policy explains how we collect, use, and
							protect your personal information when you use our service.
						</Paragraph>
						<Paragraph>
							By accessing or using the platform, you agree to the collection
							and use of information in accordance with this policy.
						</Paragraph>
					</section>

					<section>
						<Title level={4} className="text-coral">
							2. Information We Collect
						</Title>
						<Paragraph>
							We collect information that you provide directly when creating an
							account or using our services:
						</Paragraph>
						<ul style={{ paddingLeft: 24 }}>
							<li>
								<Text>
									<Text strong>Account information:</Text> name, email address,
									and authentication credentials (including Google OAuth tokens).
								</Text>
							</li>
							<li>
								<Text>
									<Text strong>Usage data:</Text> interactions with the platform,
									content generation history, and feature usage.
								</Text>
							</li>
							<li>
								<Text>
									<Text strong>Technical data:</Text> browser type, IP address,
									and device information collected automatically via standard web
									technologies.
								</Text>
							</li>
						</ul>
					</section>

					<section>
						<Title level={4} className="text-coral">
							3. How We Use Your Information
						</Title>
						<Paragraph>
							We use the information we collect for the following purposes:
						</Paragraph>
						<ul style={{ paddingLeft: 24 }}>
							<li>
								<Text>To provide, maintain, and improve our SEO platform.</Text>
							</li>
							<li>
								<Text>
									To authenticate your identity and manage your account.
								</Text>
							</li>
							<li>
								<Text>
									To communicate with you about service updates and support
									requests.
								</Text>
							</li>
							<li>
								<Text>
									To monitor usage patterns and improve the user experience.
								</Text>
							</li>
						</ul>
						<Paragraph>
							We do not sell your personal information to third parties.
						</Paragraph>
					</section>

					<section>
						<Title level={4} className="text-coral">
							4. Data Security
						</Title>
						<Paragraph>
							We implement industry-standard security measures to protect your
							data, including encrypted connections (TLS), secure authentication
							via Supabase, and access controls. However, no method of
							electronic transmission or storage is 100% secure, and we cannot
							guarantee absolute security.
						</Paragraph>
					</section>

					<section>
						<Title level={4} className="text-coral">
							5. Third-Party Services
						</Title>
						<Paragraph>
							Our platform integrates with third-party services such as Google
							OAuth for authentication and various SEO data providers. These
							services have their own privacy policies, and we encourage you to
							review them. We only share the minimum information necessary for
							these integrations to function.
						</Paragraph>
					</section>

					<section>
						<Title level={4} className="text-coral">
							6. Data Retention
						</Title>
						<Paragraph>
							We retain your personal information for as long as your account is
							active or as needed to provide you with our services. You may
							request deletion of your account and associated data at any time
							by contacting us.
						</Paragraph>
					</section>

					<section>
						<Title level={4} className="text-coral">
							7. Contact Us
						</Title>
						<Paragraph>
							If you have any questions about this Privacy Policy or our data
							practices, please contact us at:
						</Paragraph>
						<Paragraph>
							<Text strong>Agile &amp; Co</Text>
							<br />
							Email:{" "}
							<a
								href="mailto:carl@agileandco.com"
								className="text-teal-dark"
							>
								carl@agileandco.com
							</a>
						</Paragraph>
					</section>

					<Divider style={{ margin: "8px 0" }} />

					<div style={{ textAlign: "center" }}>
						<Link to="/login" className="text-coral">
							<ArrowLeftOutlined style={{ marginRight: 6 }} />
							Back to Login
						</Link>
					</div>
				</Space>
			</Card>
		</div>
	);
}
